import type { Profile } from 'src/types/profile'
import { UPDATE_ME } from '../types'

interface State {
  profile: Profile | null
}

const state: State = {
  profile: null,
}

const getters = {
  name: (state: State) => {
    return state.profile ? state.profile.name : ''
  },
  mobile: (state: State) => {
    return state.profile ? state.profile.mobile : ''
  },
  profile: (state: State) => {
    return state.profile
  },
  isInit: (state: State) => {
    return state.profile && state.profile.is_init
  },
}

const mutations = {
  [UPDATE_ME](state: State, profile: Profile) {
    state.profile = profile
  },
}

export default {
  state,
  getters,
  mutations,
}
